var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5240",
    d: "M7 6V3c0-.265.105-.52.293-.707C7.48 2.105 7.735 2 8 2h12c.265 0 .52.105.707.293.188.187.293.442.293.707v14c0 .265-.105.52-.293.707-.187.188-.442.293-.707.293h-3v3c0 .552-.45 1-1.007 1H4.007c-.132 0-.263-.024-.385-.074-.122-.05-.233-.124-.326-.217-.094-.093-.168-.203-.219-.325C3.027 21.262 3 21.132 3 21l.003-14c0-.552.45-1 1.007-1H7zM5.003 8L5 20h10V8H5.003zM9 6h8v10h2V4H9v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.c7fc11ad76c46eb9966ddf86cb17db86.svg";
export { ForwardRef as ReactComponent };